export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14775.6ae4047f.jpg";